import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { HttpParams } from '@angular/common/http';

import { InputForm, InputInterface } from 'src/app/classes/input';
import { Comment, CommentParent } from 'src/app/classes/interfaces/comment.interface';
import { CommentService } from 'src/app/classes/services/comment.service';
import { AuthService } from '../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Result } from 'src/app/classes/result';
import { PageInterface } from 'src/app/classes/page.model';
import { AppComponent } from 'src/app/app.component';
import { HeaderLayoutComponent } from 'src/app/components/header-layout/header-layout.component';
import { ModalService } from '../modal/services/modal.service';
import { Location } from '@angular/common';

let formDataInit: Comment = {
  id: 0,
  isActive: true,
  userID: 0,
  name: 'mohammad t',
  text: 'this is test',
  rate: 3,
  tableType: 1,
  email: 'm@gmail.com',
  isAccepted: false,
  rowID: 1061,
};

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
})
export class CommentsComponent {

  preComments: Comment[] | undefined = new Array<Comment>();
  @Input() rowId: number | undefined;
  @Input() tableType: number;
  @Input('title') title: string;
  @Input('data') comments: Comment[] = new Array<Comment>();

  formErrors: { [key: string]: string[] } = {};
  commentData: Comment[] = new Array<Comment>();
  replyComment: CommentParent[] | undefined = new Array<CommentParent>();

  isMoneyManagment: boolean;
  currentUrl: string;

  rateText: string = 'خوب';
  rate: number = 3;
  completedFill: boolean = false;
  loading = false;
  isLogin = false;

  device: 'sm' | 'lg' = 'lg';

  formControlInit: InputInterface[] = [
    {
      id: 1,
      label: 'نام و نام خانوادگی',
      name: 'NameInfo',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'نام',
      required: true,
      hasErr: false,
    },
    {
      id: 2,
      label: 'متن',
      name: 'textAr',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'متن',
      required: true,
      hasErr: false,
    },
    {
      id: 3,
      label: 'email',
      name: 'Email',
      type: 'email',
      class: 'input-without-icon',
      typeofVlaue: 'string',
      placeholder: 'ایمیل',
      required: true,
      hasErr: false,
    },
  ];

  formMaker = new InputForm(this.formControlInit);
  formControls!: InputInterface[];
  form: FormGroup;

  constructor(
    private _comment: CommentService,
    private _authservice: AuthService,
    private modal: ModalService,
    private toaster: ToastrService,
    private location: Location
  ) {
    this.form = new FormGroup({});

    this.formMaker.inputs.forEach((item) => {
      this.form.setControl(item.name, this.formMaker.createControl(item));
    });

    this.formControls = this.formMaker.inputs;

    var loggedIn$ = AuthService.loggedIn.asObservable();
    loggedIn$.subscribe(() => {
      this.completeUserInfo();
    });
  }

  ngOnInit() {

    if (AppComponent.isBrowser.value) {
      this.loading = true;
    } else {
      console.log('Warning: Ssr Is Not Loading');
    }

    this.getUrl();
    this.getComment();
  }

  putStyle(n: number, text: string) {
    this.rate = n;
    this.rateText = text;
  }

  get _NameInfo(): string {
    return this.form.controls['NameInfo'].value;
  }

  get _text(): string {
    return this.form.controls['textAr'].value;
  }

  get _Email(): string {
    return this.form.controls['Email'].value;
  }

  getUrl() {

    this.currentUrl = this.location.path();

    if (this.currentUrl == '/money-management') {
      this.isMoneyManagment = true;
    } else {
      this.isMoneyManagment = false;
    }
  }
  
  getComment() {

    if (!this.rowId || !this.tableType) return;
  
    const params = new HttpParams()
      .set('pageIndex', '0')
      .set('pageSize', '100')
      .set('accending', 'true');
  
    this._comment
      .get(`Comment/GetByTableTypeAndRowId/${this.rowId}/${this.tableType}`, params)
      .subscribe((res: Result<PageInterface<Comment[]>>) => {
        this.preComments = res.data?.items?.filter(x => x.isAccepted);
      });
  
  }
  

  async commentServices() {

    this.formErrors = {};

    let formData = { ...formDataInit };

    formData.name = this._NameInfo;
    formData.text = this._text;
    formData.email = this._Email;
    formData.rate = this.rate;
    formData.tableType = this.tableType;
    formData.rowID = this.rowId!;
    formData.title = this.title;
    formData.userID = this._authservice._user.id;

    if (await this.checkFormValidation(formData)) {

      let address = 'Comment?authorID=' + this._authservice._user.id;

      if (this._authservice._user.id == 0) {
        address = 'Comment';
        formData.userID = null;
      }

      const apiRes = this._comment.post(address, formData);
      const lastVal = await lastValueFrom(apiRes);

      if (lastVal && lastVal.success) {

        this.toaster.success('با موفقیت ثبت شد');
        this.form.controls['textAr'].setValue('');

      } else {

        this.toaster.error('خطا در عملیات!!!');

      }
    }
  }

  completeUserInfo() {

    if (this._authservice._user.id != 0) {

      this.isLogin = true;
      this.completedFill = true;

      this.form.controls['NameInfo'].setValue(
        this._authservice._user.firstName + ' ' + this._authservice._user.lastName
      );

      this.form.controls['NameInfo'].disable();
      this.form.controls['Email'].setValue(this._authservice._user.username);
      this.form.controls['Email'].disable();
    }
  }

  async checkFormValidation(_formData: Comment) {

    for (const controlName in this.form.controls) {

      const control = this.form.controls[controlName];

      if (control.invalid) {

        this.formErrors[controlName] = [];

        if (control.errors?.['required']) {
          this.formErrors[controlName].push(`${controlName} is required.`);
        }

        if (control.errors?.['email']) {
          this.formErrors[controlName].push(`Invalid ${controlName} format.`);
        }
      }
    }

    let erorrKeyName = Object.keys(this.formErrors);

    this.formControlInit.forEach((x) => {

      if (erorrKeyName.indexOf(x.name) > -1) {
        x.hasErr = true;
      }

      setTimeout(() => {
        x.hasErr = false;
      }, 10000);

    });

    return Object.keys(this.formErrors).length === 0;
  }

  openModal() {

    HeaderLayoutComponent.modalView = 'login';

    this.modal.open().subscribe({
      next: (action) => {
        console.log(action);
      },
      complete: () => {
        HeaderLayoutComponent.modalStatus = false;
      },
    });

    HeaderLayoutComponent.modalStatus = true;
  }
}
